import React, { createContext, useState } from "react"

type InterfaceContextType = {
  cookieBannerVisible: boolean
  cookieModalVisible: boolean
  setCookieBannerVisible: (isVisible: boolean) => void
  setCookieModalVisible: (isVisible: boolean) => void
}

export const defaultContext: InterfaceContextType = {
  cookieBannerVisible: false,
  cookieModalVisible: false,
  setCookieBannerVisible: () => {},
  setCookieModalVisible: () => {},
}

export const InterfaceContext = createContext(defaultContext)

type Props = {
  children: React.ReactNode
}

export const InterfaceProvider = ({ children }: Props) => {
  const [cookieBannerVisible, setCookieBannerVisible] = useState(false)
  const [cookieModalVisible, setCookieModalVisible] = useState(false)

  return (
    <InterfaceContext.Provider
      value={{
        cookieBannerVisible,
        cookieModalVisible,
        setCookieBannerVisible,
        setCookieModalVisible,
      }}
    >
      {children}
    </InterfaceContext.Provider>
  )
}
